var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMoneyLogo2 = function SvgMoneyLogo2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8542 54.564L23.5742 79.9868V69.306L86.8542 44.1733V54.564Z",
    fill: "#FFEEDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5724 79.9999L2 62.7394V52.5465L23.5724 69.3192V79.9999Z",
    fill: "#FFF9F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5742 71.0861V71.64L86.8542 46.6523V46.0985L23.5742 71.0861ZM23.5742 73.8289L86.8542 48.8412V48.2874L23.5742 73.275V73.8289ZM23.5742 76.0309L86.8542 51.0301V50.4763L23.5742 75.4771V76.0309ZM23.5742 78.2198L86.8542 53.2322V52.6784L23.5742 77.666V78.2198Z",
    fill: "#DD9C7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 52.5465L65.2931 27.5853L86.8524 44.1734L23.5724 69.306L2 52.5465Z",
    fill: "#FFF9F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9141 46.6656L50.1957 33.5454L71.7681 50.3049L38.4865 63.4251L16.9141 46.6656Z",
    fill: "#DD9C7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7344 48.1028L52.2138 35.1013L53.1632 35.8266L19.631 48.7885L18.7344 48.1028Z",
    fill: "#B3533B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9336 65.2052L42.0206 58.8495L44.0249 60.2736L27.8719 66.5765L25.9336 65.2052Z",
    fill: "#B3533B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 54.0366V54.5904L23.5724 71.64V71.0862L2 54.0366ZM2 56.7925L23.5724 73.8421V73.2882L2 56.2386V56.7925ZM2 58.9813L23.5724 76.031V75.4771L2 58.4275V58.9813ZM2 61.1834L23.5724 78.233V77.666L2 60.6296V61.1834Z",
    fill: "#FFEEDA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6028 50.1467C19.9984 51.2147 17.6776 53.0476 14.4338 54.2475C11.1901 55.4343 8.23638 55.5398 7.8408 54.4585C7.44522 53.3904 9.76597 51.5576 13.0097 50.3576C16.2667 49.1841 19.2204 49.0786 19.6028 50.1467Z",
    fill: "#DD9C7E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7585 49.4874L51.473 51.162L42.7966 44.358L41.7812 41.3252L42.4142 41.0746L47.0689 42.6702L55.7585 49.4874Z",
    fill: "#8AC4DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8132 53.4564L39.5277 55.131L30.8644 48.3138L29.8359 45.281L30.4689 45.0305L35.1367 46.6392L43.8132 53.4564Z",
    fill: "#B3533B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8462 52.3355L35.6227 57.1221L30.4934 53.1267L29.4648 50.0939L38.0358 46.7314L42.7037 48.327L47.8462 52.3355Z",
    fill: "#B3533B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4595 35.4932C64.7218 34.343 67.0583 32.5365 66.6781 31.4582C66.298 30.3799 63.3451 30.4381 60.0828 31.5883C56.8204 32.7385 54.484 34.545 54.8641 35.6233C55.2443 36.7016 58.1971 36.6433 61.4595 35.4932Z",
    fill: "#DD9C7E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0625 58.4671L60.0565 47.5622L61.0059 48.2874L32.9592 59.1396L32.0625 58.4671Z",
    fill: "#B3533B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5352 49.316L72.3342 42.6833L77.4768 46.0854L60.1635 52.8235L55.5352 49.316Z",
    fill: "#B3533B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8125 40.8768L44.748 35.7343L66.3073 52.4806L53.4113 57.544L31.8125 40.8768Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4141 68.0665L66.31 62.8449V52.4806L53.4141 57.544V68.0665Z",
    fill: "#CBCDD6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2414 38.2792L35.2031 62.8053V52.507L96.2414 28.4424V38.2792Z",
    fill: "#FFEEDA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2046 62.8185L14.4102 46.1777V36.3409L35.2046 52.5202V62.8185Z",
    fill: "#FFF9F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2031 54.2212V54.7618L96.2282 30.6576V30.117L35.2031 54.2212ZM35.2031 56.8716L96.2282 32.7674V32.2268L35.2031 56.3309V56.8716ZM35.2031 58.9813L96.2282 34.8772V34.3366L35.2031 58.4539V58.9813ZM35.2031 61.1043L96.2282 37.0001V36.4595L35.2031 60.5637V61.1043Z",
    fill: "#DD9C7E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4102 36.3409L75.4353 12.2762L96.2429 28.4424L35.2046 52.507L14.4102 36.3409Z",
    fill: "#FFF9F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7969 30.6709L60.8918 18.0122L81.6862 34.1784L49.5913 46.837L28.7969 30.6709Z",
    fill: "#DD9C7E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5352 32.0685L62.8278 19.5154L63.7509 20.2142L31.4054 32.7147L30.5352 32.0685Z",
    fill: "#B3533B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4844 48.5511L52.9912 42.4196L54.9295 43.8042L39.3568 49.8698L37.4844 48.5511Z",
    fill: "#B3533B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4102 37.7781V38.3188L35.2178 54.7486V54.208L14.4102 37.7781ZM14.4102 40.4285L35.2178 56.8584V56.3178L14.4102 39.9011V40.4285ZM14.4102 42.5515L35.2178 58.9814V58.4407L14.4102 42.0109V42.5515ZM14.4102 44.6613L35.2178 61.0911V60.5505L14.4102 44.1338V44.6613Z",
    fill: "#FFEEDA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4003 37.9853C29.5318 36.8373 31.7637 35.0696 31.3852 34.0372C31.0067 33.0047 28.1612 33.0984 25.0296 34.2464C21.898 35.3945 19.6662 37.1621 20.0447 38.1946C20.4232 39.227 23.2687 39.1334 26.4003 37.9853Z",
    fill: "#DD9C7E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2457 33.3872L62.1185 35.009L53.7585 28.4424L52.7695 25.5151L53.3761 25.2777L57.8725 26.8205L66.2457 33.3872Z",
    fill: "#8AC4DE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7315 37.2111L50.5911 38.833L42.2311 32.2663L41.2422 29.339L41.8619 29.1017L46.3584 30.6445L54.7315 37.2111Z",
    fill: "#8AC4DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.622 36.1299L46.8336 40.745L41.8757 36.8947L40.8867 33.9805L49.1544 30.7368L53.6508 32.2795L58.622 36.1299Z",
    fill: "#B3533B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7306 19.889C74.8762 18.78 77.1298 17.0402 76.7642 16.0031C76.3985 14.9661 73.5521 15.0244 70.4065 16.1334C67.2609 17.2424 65.0073 18.9821 65.373 20.0192C65.7386 21.0563 68.585 20.998 71.7306 19.889Z",
    fill: "#DD9C7E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3945 42.0504L70.3864 31.5411L71.3226 32.24L44.2516 42.7098L43.3945 42.0504Z",
    fill: "#B3533B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0352 33.2157L82.2408 26.8337L87.1988 30.117L70.492 36.6178L66.0352 33.2157Z",
    fill: "#B3533B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1562 25.0931L55.6303 20.1351L76.4247 36.2749L63.9902 41.2724L43.1562 25.0931Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9883 51.307L76.4227 46.4941V36.2749L63.9883 41.2724V51.307Z",
    fill: "#CBCDD6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.827 26.003L40.7891 50.5291V40.2307L101.827 16.1661V26.003Z",
    fill: "#FFEEDA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7905 50.5423L19.9961 33.9015V24.0646L40.7905 40.244V50.5423Z",
    fill: "#FFF9F1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7891 41.9449V42.4856L101.814 18.3814V17.8408L40.7891 41.9449ZM40.7891 44.5953L101.814 20.4912V19.9505L40.7891 44.0547V44.5953ZM40.7891 46.7051L101.814 22.6009V22.0603L40.7891 46.1777V46.7051ZM40.7891 48.8281L101.814 24.7239V24.1833L40.7891 48.3006V48.8281Z",
    fill: "#DD9C7E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 24.0646L81.0212 0L101.829 16.1661L40.7905 40.2308L19.9961 24.0646Z",
    fill: "#FFF9F1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3828 18.3946L66.4777 5.73596L87.2721 21.9021L55.1772 34.5608L34.3828 18.3946Z",
    fill: "#F6B192"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1211 19.7923L68.4138 7.23914L69.3368 7.938L36.9782 20.4384L36.1211 19.7923Z",
    fill: "#B3533B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0703 36.2749L58.5771 30.1566L60.5155 31.5279L44.9427 37.5935L43.0703 36.2749Z",
    fill: "#B3533B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 25.5019V26.0425L40.8037 42.4724V41.9318L19.9961 25.5019ZM19.9961 28.1523L40.8037 44.5822V44.0415L19.9961 27.6249V28.1523ZM19.9961 30.2753L40.8037 46.7051V46.1645L19.9961 29.7346V30.2753ZM19.9961 32.3982L40.8037 48.8281V48.2875L19.9961 31.8576V32.3982Z",
    fill: "#FFEEDA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9823 25.7088C35.1139 24.5608 37.3457 22.7931 36.9672 21.7607C36.5887 20.7282 33.7432 20.8219 30.6116 21.9699C27.4801 23.118 25.2482 24.8856 25.6267 25.9181C26.0052 26.9506 28.8507 26.8569 31.9823 25.7088Z",
    fill: "#DD9C7E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1993 20.7813L81.9448 24.025L61.0977 7.85889L69.339 4.61511L90.1993 20.7813Z",
    fill: "#F6B192"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8316 21.1109L67.7044 22.7328L59.3444 16.1661L58.3555 13.2388L58.962 13.0015L63.4585 14.5442L71.8316 21.1109Z",
    fill: "#8AC4DE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M77.937 16.5485L77.0272 16.7859L71.3308 12.0389L71.4231 11.6169L67.876 9.07202L67.5859 9.1907L69.4847 11.6037L69.999 12.1971L70.8693 12.3554L75.8272 17.4452L75.3393 17.8935L75.8272 19.5681L80.2182 17.854L77.937 16.5485Z",
    fill: "#B3533B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3165 7.61238C80.4621 6.50336 82.7157 4.76361 82.3501 3.72653C81.9845 2.68944 79.138 2.74775 75.9925 3.85676C72.8469 4.96578 70.5933 6.70553 70.9589 7.74261C71.3245 8.7797 74.171 8.72139 77.3165 7.61238Z",
    fill: "#DD9C7E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9805 29.7742L75.9724 19.2649L76.8954 19.9638L49.8376 30.4335L48.9805 29.7742Z",
    fill: "#B3533B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6211 20.9527L87.8268 14.5574L92.7847 17.8408L76.078 24.3415L71.6211 20.9527Z",
    fill: "#B3533B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7422 12.8169L61.2162 7.85889L82.0106 23.9987L69.5762 28.9962L48.7422 12.8169Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5742 39.0308L82.0087 34.0465V23.9987L69.5742 28.9962V39.0308Z",
    fill: "#CBCDD6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130.722 11.1158L70.8438 43.7646L79.085 50.5554L138.594 17.6034L130.722 11.1158Z",
    fill: "#FFF9F1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M70.832 43.7514L70.8452 71.1917L79.0206 77.9297L79.0733 50.5554L70.832 43.7514Z",
    fill: "#FFEEDA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M137.263 16.4958L136.841 16.1398L77.2929 49.0786L77.7149 49.4346L137.263 16.4958ZM76.0271 48.0369L135.562 15.1113L135.14 14.7552L75.5919 47.6809L76.0271 48.0369ZM74.3261 46.6392L133.861 13.7135L133.439 13.3575L73.9041 46.2832L74.3261 46.6392ZM72.6383 45.2415L132.173 12.3026L131.751 11.9466L72.2031 44.8854L72.6383 45.2415Z",
    fill: "#FFEEDA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138.594 17.6034L79.0855 50.5686L79.0195 77.9297L138.594 44.4635V17.6034Z",
    fill: "#FFEEDA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M124.577 25.3832L98.7188 39.6769V66.8534L124.577 52.3355V25.3832Z",
    fill: "#F6B192"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M133.149 43.2899L118.011 51.6631L117.84 54.1289L132.964 45.6766L133.149 43.2899Z",
    fill: "#DD9C7E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M114.783 53.6278L99.6455 62.001L99.4609 64.4668L114.599 56.0013L114.783 53.6278Z",
    fill: "#B3533B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M132.637 22.6273L117.513 31.0005L117.328 33.4531L132.466 25.0008L132.637 22.6273Z",
    fill: "#DD9C7E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7134 49.4346L77.2915 49.0786L77.2783 76.4925L77.7002 76.8485L77.7134 49.4346ZM76.0388 75.464L76.0256 48.0369L75.6037 47.6809L75.6168 75.108L76.0388 75.464ZM74.3246 74.0531V46.626L73.9027 46.27V73.697L74.3246 74.0531ZM72.6368 72.6553V45.2283L72.2148 44.8723V72.2993L72.6368 72.6553Z",
    fill: "#DD9C7E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7217 39.6769L90.6914 44.147V71.3762L98.7217 66.8534V39.6769Z",
    fill: "#DD9C7E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7217 41.9449L90.6914 46.1777V51.9664L98.7217 47.6282V41.9449Z",
    fill: "#B3533B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M107.121 62.146L119.252 55.3288V28.2973L107.121 35.0354V62.146Z",
    fill: "#CBCDD6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0234 28.3237L111.26 21.6911L119.251 28.2973L107.12 35.0354L99.0234 28.3237Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5698 51.8102C88.9031 50.1167 88.0842 48.5296 86.7409 48.2652C85.3975 48.0008 84.0383 49.1593 83.705 50.8528C83.3717 52.5463 84.1906 54.1335 85.5339 54.3979C86.8773 54.6623 88.2365 53.5037 88.5698 51.8102Z",
    fill: "#DD9C7E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M132.768 42.2482C130.5 43.5536 128.1 43.6591 127.414 42.4724C126.729 41.2856 128.021 39.2681 130.289 37.9495C132.557 36.6441 134.957 36.5386 135.642 37.7254C136.328 38.9121 135.049 40.9296 132.768 42.2482Z",
    fill: "#DD9C7E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M104.364 46.5733V45.9271C104.72 45.6898 104.905 45.6107 105.01 45.0964C105.116 44.5558 105.102 43.6987 104.852 43.3427C104.43 42.802 103.467 42.6042 102.874 42.9471C102.188 43.5141 102.096 44.2789 102.597 45.4656L102.676 46.415C102.584 46.5469 101.779 47.3776 101.357 47.7996C101.199 47.9578 101.107 48.1688 101.094 48.3929L101.845 51.2807L101.476 55.2497H102.294L102.861 60.9857L102.887 61.1571L102.94 61.1439L102.953 61.1571L103.032 61.1175L105.814 59.2583L106.685 55.2497L104.944 52.085L105.801 51.4257V48.2611C105.814 47.3776 105.155 46.7051 104.364 46.5733Z",
    fill: "#B3533B"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyLogo2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/money-logo-2.eb8b01ad.svg";